<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Recharge 100Mo d'internet</div>
</div>
<div class="w-100 pt-3">
    <span>
        Vous avez consommé <strong>{{ consumption.total.data.consumption }}</strong> sur les <strong>{{ consumption.total.data.limit }}</strong>. Voulez-vous souscrire à une recharge de 100 Mo ?
        <br/>
        Cette option vous coûtera <strong>{{ priceDetails?.price }}
        @if (priceDetails?.perMonth) {
            <span>/mois</span>
        }</strong>.
        <br/>
        Elle est sans engagement et les <strong>100 Mo</strong> sont utilisables uniquement sur le mois en cours.
        Pour plus d'informations, vous pouvez consulter le <a [href]="line.offer.offerGt" target="_blank">Guide Tarifaire de votre forfait</a> (rubrique "Infos et Documents").
    </span>
</div>
<div class="w-100 pt-3 text-center cta_container">
    <button type="button" class="cta_cancel column" (click)="cancel()">Non<span></span></button>
    <button type="button" class="cta_btn level_2 column" (click)="send()">Oui<span></span></button>
</div>

